import { smartRequest } from '../../api/index';

// POST (JSON body)
export const postData = <T = any>(url: string, data: object = {}, init: RequestInit = {}) =>
    smartRequest<T>(url, { method: 'POST', body: JSON.stringify(data), ...init });

// GET
export const getData = <T = any>(url: string) => smartRequest<T>(url, { method: 'GET' });
export const getDataWithBody = <T = any>(url: string, data: object = {}) => smartRequest<T>(url, { method: 'GET', body: JSON.stringify(data) });

// DELETE
export const deleteData = <T = any>(url: string) => smartRequest<T>(url, { method: 'DELETE' });
export const deleteDataWithBody = <T = any>(url: string, data: object = {}) => smartRequest<T>(url, { method: 'DELETE', body: JSON.stringify(data) });

// PUT (JSON body)
export const putData = <T = any>(url: string, data: object = {}) => smartRequest<T>(url, { method: 'PUT', body: JSON.stringify(data) });

// PATCH (JSON body)
export const patchData = <T = any>(url: string, data: object = {}) => smartRequest<T>(url, { method: 'PATCH', body: JSON.stringify(data) });

// DELETE
export const deleteDataById = <T = any>(url: string) => smartRequest<T>(url, { method: 'DELETE' });
